import { Component, OnInit } from '@angular/core';
declare let $: any;
declare let bootstrap: any;
import { Router, ActivatedRoute } from '@angular/router';
// declare let Swiper: any;
// declare let bootstrap: any;
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import Swal from 'sweetalert2';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html', 
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
 
 
  content_update_date:any='';
  show_content_update_date:boolean=false;
  constructor(private fciwebservice: fciWebsiteService,private routerparam: ActivatedRoute,private route: Router,private httpservice: CustomServiceService, public translate: TranslateService, private ngxLoader: NgxUiLoaderService) { }

  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  FooterYear:any= new Date();
  datetime:any = this.httpservice.currentDateTime(); 
  windowScrolled = false;
  visito_no:number=0;
   scrollToTop(): void {
    window.scrollTo(0, 0);
  }
  language: any="";
  menutimeInteval:any = null;
  impLinktimeInteval:any = null;
  visitorCountertimeInterval:any = null;
  ngOnInit(): void {
    let curl:any = this.route.url;
    curl= curl.split('/');
    if(curl.includes("view")){
      this.show_content_update_date= true;
    } else{
      this.show_content_update_date= false;
    }
    if(!window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`)){
      this.content_update_date = new Date();
    } else {
      this.content_update_date = window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`);
    }
    setTimeout(()=>{
      if(!window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`)){
        this.content_update_date = new Date();
      } else {
        this.content_update_date = window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`);
      }
    },1000)
    setTimeout(()=>{
      if(!window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`)){
        this.content_update_date = new Date();
      } else {
        this.content_update_date = window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`);
      }
    },2000)
    setTimeout(()=>{
      if(!window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`)){
        this.content_update_date = new Date();
      } else {
        this.content_update_date = window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`);
      }
    },3000)
    setTimeout(()=>{
      if(!window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`)){
        this.content_update_date = new Date();
      } else {
        this.content_update_date = window.sessionStorage.getItem(`content_update_on${environment.ZONE_CODE}`);
      }
    },4000)
    this.ngxLoader.start();
    this.language = sessionStorage.getItem('locale');//dynamic
    this.getZoneAbout();
    this.menutimeInteval = setInterval(():any=>{
      if(!this.fciwebservice.MenuData().progress){
        this.getallFooterMenu();
        clearInterval(this.menutimeInteval);
      }
    }, 500);

    this.visitorCountertimeInterval = setInterval(():any=>{
      if(!this.fciwebservice.VisitorCounterData().progress){
        this.getVisitorCounter();
        clearInterval(this.visitorCountertimeInterval);
      }
    }, 500);

 
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    // FOR SCROLL TO TOP - STARTS
    window.addEventListener('scroll', () => {
      this.windowScrolled = window.pageYOffset !== 0;
    }); 
    // FOR SCROLL TO TOP - ENDS
    // this.stopLoader()
    this.ngxLoader.stop();
  }
  update_time:any='00:00:00'; 
  lastUpdatedata:any = {
    "intId": '',
    "total_count": 0,
    "dtmCreatedOn": "2023-08-10 00:00:00",
    "stmUpdatedOn": "2023-08-17 00:00:00"
  };
  content_apiresponse:any;
  visitorc :any =[];
  getVisitorCounter():any{
    this.visitorc =[];
    let alldata:any = this.fciwebservice.VisitorCounterData();
    if(alldata.visito_no <= 0){
      return false;
    }
    this.visito_no=alldata.visito_no;
    this.lastUpdatedata = alldata.lastUpdatedata;
    this.update_time = alldata.update_time;
  }

  stopLoader(){
    let obj = this;
    window.onload = function(e:any){ 
      obj.ngxLoader.stop();
    }
  }



 footerGlobalMenu:any[]=[];
 footerPrimaryMenu:any[]=[];
 getallFooterMenu():boolean {
  this.footerGlobalMenu = [];
  this.footerPrimaryMenu = [];
  let allmenu:any = this.fciwebservice.getFilterMenus(2);
  if(allmenu.length <= 0){
    return false;
  }
    for(let loop of allmenu)
    {
        if(loop["menuType"]==1) //Global Menu
          {
            this.footerGlobalMenu.push(loop);
          } else if(loop["menuType"]==2){ //Secondary Menu
            this.footerPrimaryMenu.push(loop);
          }
    }
  return true;
 }




  goToContentPage(menu:any)
  {
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this.route.navigate(['./view/'+menu["menuAlias"]]));
  }
  
  goToExtLink(url:any)
  {
     Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
    }
  });
  }

  goToPluginPage(link:any,menudtl:any)
    {
      sessionStorage.removeItem(btoa(menudtl.selectPlugin));
      sessionStorage.setItem(btoa(menudtl.selectPlugin),JSON.stringify(menudtl));
      // this.route.navigate([link,""]);
      this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate([link]));
    }






    zone_apirespons: any;
    zoneList: any[] = [];
    zoneDetails:any={
      "title":"",
      "titleInHindi":"",
      "selectZone": "",
      "selectRegion": "",
      "readMoreMenuType": "",
      "readMoreLinkType": "",
      "selectMenu": "",
      "description": "",
      "descriptionInHindi": "",
      "jsonOptTxtDetails": {"ZONE_ID":"Headquarter","REGION_ID":"--","INTMENUTYPE":"Secondary","INTLINKTYPE":"Content Page","MENU_ID":"Header\/Insight\/Overview\/First Test"},
      "id": "",
      "noOfRec": "",
      'backgroundImage': "",
      'backgroundImage_details':{"fileType": "","fileSize": ""},
      'address': "Food Corporation Of India (FCI), 16-20, Barakhamba Lane, New-Delhi-110001, India",
      'addressInHindi': "भारतीय खाद्य निगम, 16-20, बाराखंभा लेन, नई दिल्ली-110001, भारत",
      "helpdeskNumber": "011-4352 7462",
      "feedbackEmailId": "webmaster.fci@gov.in",
  };
    TotalzoneList:number = 0;
    getZoneAbout() { 
      var query:any = [];
      query = [
        { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
      ];
      if(environment.ZONE_ID  > 0){
        query.push({ "columnName": "ZONE_ID", "operator": "=", "value":environment.ZONE_ID, "joinoperator": "and" },);
      }
      let params = [
        {
          "secSlNo": 1,
          "offSet": 0,
          "noOfRecords": 0,
          "orderBy": [],
          "condition": query,
          "viewParameters": ""
        }];
      this.httpservice.getZoneAbout(params).subscribe((response: HttpEvent<any>) => { 
        switch (response.type) { 
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.zone_apirespons = response.body;
            let respData = this.zone_apirespons.RESPONSE_DATA;
            let respToken = this.zone_apirespons.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
            if (respToken == verifyToken) {
              let response_: any = Buffer.from(respData, 'base64');
              response_ = JSON.parse(response_);
              if(response_.status==200){
                this.zoneList = response_.result.sec_1;
                this.TotalzoneList = this.zoneList.length;
                if(this.zoneList.length > 0){
                  this.zoneDetails = response_.result.sec_1[0];
                }
              }
          
            } 
        }
      });
    }


}
